import React, { useEffect, useState } from 'react';
import { concernsAPI } from '../../services/api';

const STATUS_COLOR = { pending: 'orange', acknowledged: 'blue', in_progress: 'purple', resolved: 'green' };

export default function HRConcerns() {
  const [concerns, setConcerns] = useState([]);
  const [filter, setFilter] = useState('');
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({ status: '', hr_response: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = (s) => {
    setLoading(true);
    concernsAPI.list(s ? { concern_status: s } : {})
      .then(({ data }) => setConcerns(data))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(filter); }, [filter]);

  const openModal = (c) => {
    setSelected(c);
    setForm({ status: c.status, hr_response: c.hr_response || '' });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await concernsAPI.update(selected.id, form);
      setSelected(null);
      load(filter);
    } finally { setSaving(false); }
  };

  return (
    <div className="page">
      <div className="page-header"><h2>Concerns &amp; Suggestions</h2></div>

      <div className="filter-bar">
        {['', 'pending', 'acknowledged', 'in_progress', 'resolved'].map((s) => (
          <button key={s} className={`filter-btn${filter === s ? ' active' : ''}`} onClick={() => setFilter(s)}>
            {s ? s.replace('_', ' ') : 'All'}
          </button>
        ))}
      </div>

      {loading ? <div className="page-loading">Loading...</div> : (
        <div className="concern-list">
          {concerns.length === 0 ? (
            <div className="empty-state">No submissions.</div>
          ) : concerns.map((c) => (
            <div key={c.id} className="concern-card">
              <div className="concern-header">
                <div>
                  <span className={`badge badge-${c.type === 'suggestion' ? 'blue' : 'orange'}`}>{c.type}</span>
                  {c.is_confidential && <span className="badge badge-gray ml-2">Confidential</span>}
                  <h4>{c.title}</h4>
                  <small className="text-muted">By: {c.submitted_by?.full_name} · {new Date(c.created_at).toLocaleDateString()}</small>
                </div>
                <div className="flex-col-end">
                  <span className={`badge badge-${STATUS_COLOR[c.status]}`}>{c.status}</span>
                  <button className="btn btn-sm btn-primary mt-2" onClick={() => openModal(c)}>Respond</button>
                </div>
              </div>
              <p className="concern-content">{c.content}</p>
              {c.hr_response && (
                <div className="hr-response">
                  <strong>HR Response:</strong> {c.hr_response}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Respond to {selected.type}</h3>
              <button className="modal-close" onClick={() => setSelected(null)}>×</button>
            </div>
            <div className="modal-body">
              <p><strong>{selected.title}</strong></p>
              <form onSubmit={handleUpdate}>
                <div className="form-group">
                  <label>Status</label>
                  <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                    <option value="pending">Pending</option>
                    <option value="acknowledged">Acknowledged</option>
                    <option value="in_progress">In Progress</option>
                    <option value="resolved">Resolved</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Response</label>
                  <textarea rows={4} value={form.hr_response} onChange={(e) => setForm({ ...form, hr_response: e.target.value })} />
                </div>
                <div className="form-actions">
                  <button type="button" className="btn btn-ghost" onClick={() => setSelected(null)}>Cancel</button>
                  <button type="submit" className="btn btn-primary" disabled={saving}>
                    {saving ? 'Saving...' : 'Save Response'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
